import styled from 'styled-components'

export const HiddenRadioUi = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`
